import { AnimatedBackground } from "../../../../components/utils/AnimatedBackground";
import { LoadingView } from "../../../../components/utils/LoadingView";
import { MeetingAccessibilityWithVods } from "../../../../hooks/meeting";
import { VodPlayerContentPage } from "./player";
import styles from "./MeetingReplayView.module.css";

export interface MeetingReplayViewProps {
  /** `useMeetingAccessibility` contract: `undefined` = loading, `null` = unknown id / rejection. */
  accessibility: MeetingAccessibilityWithVods | null | undefined;
}

/**
 * Accessibility payload → replay screen: loading, denial (no access / bad
 * link), no-VODs, or the player. Fills its parent (100%×100% in every state) —
 * positioning is the caller's concern. Shared by the /player/:id route and the
 * /list `?vodId=` overlay.
 */
export const MeetingReplayView = ({ accessibility }: MeetingReplayViewProps) => {
  if (accessibility === undefined) return <LoadingView message="Chargement du replay" />;

  if (accessibility === null || !accessibility.canAccess) {
    const message = accessibility === null
      ? "Ce replay n'existe pas ou le lien est invalide."
      : "Ce replay ne vous est pas accessible.";
    return (
      <AnimatedBackground contentClassName={styles.centered}>
        <div className={styles.message}>
          <h1 className={styles.title}>Replay indisponible</h1>
          <p className={styles.subtitle}>{message}</p>
        </div>
      </AnimatedBackground>
    );
  }

  const vods = accessibility.vods ?? [];
  if (!vods.length) {
    return (
      <AnimatedBackground contentClassName={styles.centered}>
        <div className={styles.message}>
          <h1 className={styles.title}>{accessibility.name ?? "Replay"}</h1>
          <p className={styles.subtitle}>Aucun replay disponible pour ce meeting.</p>
        </div>
      </AnimatedBackground>
    );
  }

  // The room leads the course name, as in the agenda rows.
  const meetingName = [accessibility.room?.name, accessibility.name].filter(Boolean).join(" · ") || undefined;
  return <VodPlayerContentPage vods={vods} meetingName={meetingName} />;
};
